if (!customElements.get('content-tabs')) {
  class ContentTabs extends HTMLElement {
    constructor() {
      super();
      this.onClickMenuItem = this.onClickMenuItem.bind(this);
      this.parentContainer = this.closest('[data-content-tabs-container]');
      this.menuButtons = this.querySelectorAll('.content-tabs__nav button');
      this.carousel = this.querySelector('swiper-carousel');
    }

    connectedCallback() {
      this.menuButtons.forEach(btn => {
        btn.addEventListener('click', this.onClickMenuItem);
      });

      this.carousel.swiper.on('slideChange', e => {
        this.menuButtons.forEach((btn, index) => {
          if (index === e.activeIndex) {
            btn.parentElement.classList.add('is-active');
          } else {
            btn.parentElement.classList.remove('is-active');
          }
        });
        this.updateBackground(e.activeIndex);
      });
    }

    disconnectedCallback() {
      this.menuButtons.forEach(btn => {
        btn.removeAventlistener('click', this.onClickMenuItem);
      });
    }

    onClickMenuItem(e) {
      this.menuButtons.forEach(btn => {
        if (btn === e.target) {
          btn.parentElement.classList.add('is-active');
          const index = Array.from(
            e.target.parentElement.parentElement.children,
          ).indexOf(e.target.parentElement);
          this.selectSlide(index);
        } else {
          btn.parentElement.classList.remove('is-active');
        }
      });
    }

    selectSlide(index) {
      if (this.carousel.swiper) {
        this.carousel.swiper.slideTo(index);
      }
    }

    updateBackground(index) {
      if (!this.parentContainer) {
        return;
      }

      const nextColor = this.parentContainer.dataset[`bg-${index}`];

      if (nextColor) {
        this.parentContainer.dataset.background = nextColor;
      }
    }
  }

  customElements.define('content-tabs', ContentTabs);
}
